import buildUrl from "./BuildUrl";

/**
 * Adds the source code to any external support links.
 *
 * @param {string} sourcecode
 *   The sourcecode
 */
const addSourceCodeToSupportLinks = (sourcecode) => {
  const { links } = document;

  for (let j = links.length - 1; j >= 0; j -= 1) {
    const link = links[j].href;

    if (link.contains("support.wwf.org.uk")) {
      links[j].href = buildUrl(link, { name: "pc", value: sourcecode });
    }
  }
};

export default addSourceCodeToSupportLinks;
